import * as storeTypes from './login.store-types';
import {LoginForm} from './login-form.models';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        loginForm: new LoginForm,
        isActiveRequest: false,
    },
    mutations: {
        [storeTypes.SET_LOGIN_FORM]: (state, loginForm) => state.loginForm = loginForm,
        [storeTypes.SET_IS_ACTIVE_REQUEST]: (state, isActive) => state.isActiveRequest = isActive,
    },
    actions: {
        [storeTypes.ACTION_LOGIN](store, loginForm) {
            store.commit(storeTypes.SET_LOGIN_FORM, {...loginForm});
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {user, success}} = await axios.post('/api/auth/login', {...store.state.loginForm});

                        if (success) {
                            store.commit(storeTypes.SET_LOGIN_FORM, new LoginForm);
                            return resolve(user);
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
    },
    getters: {
        [storeTypes.GET_LOGIN_FORM]: state => state.loginForm,
        [storeTypes.GET_IS_ACTIVE_REQUEST]: state => state.isActiveRequest,
    },
}